<template>
	<v-card v-if="product" class="product_container" @click="toCompare()" outlined :ripple="false">
		<img v-bind:src="product.grid_image" />
		<div class="description_container">
			<h2>{{product.name}}</h2>
            <p>{{product.extra_description}}</p>
		</div>
	</v-card>
</template>


<script>
import store from '../services/product/store';

export default {
	name: "GridListProduct",
	data: () => {
		return {
			sharedState: store.state
		};
    },
    props: {
		product: Object
	},
	methods: {
		toCompare() {
			store.setSelectedProduct(this.product);
			this.$router.push(`compare/${this.product.id}`);
		}
    },
};
</script>

<style lang="scss" scoped>
	.description_container {
		margin-left: 10px;
	}
	.product_container {
		// border: 1px solid grey;
		padding: 15px 24px;

		img {
			width: 100%;
		}

		h2 {
			font-weight: bold;
			color: black;
			font-size: 1.2rem;
		}

        p {
            font-size: 0.9rem;
            margin: 0;
            color: #707070;
        }

		// .lense_description {
		// 	width: 100%;
		// 	margin: 5px 2px;

		// 	p {
		// 		font-size: 14px;
		// 		margin: 0;
		// 		color: #707070;
		// 	}
		// 	i {
		// 		float: left;
		// 		font-size: 18px;
		// 		margin-right: 4px;
		// 		color: #707070;
		// 	}
		// }
	}

	.product_container:hover {
		box-shadow: 0px 2px 12px rgba(60, 64, 67, 0.3);
		cursor: pointer;
	}

    @media screen and (max-width: 600px) {

        .product_container {
            padding: 5px 15px;
            // box-shadow: 0px 0px 2px rgba(60, 64, 67, 0.3);

            h2 {
                font-weight: bold;
                color: black;
                font-size: 1.3rem;
            }

            p {
                font-size: 1rem;
                margin: 0;
                color: #707070;
            }
        }

        .product_container:hover {
            box-shadow: none;
            cursor: pointer;
        }
    }
</style>




